import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuctionCarousel, {
  AUCTION_CAROUSEL_TYPE,
  imgBreakpoints,
} from "../../../components/auctions/auction-carousel/auction-carousel.component";
import Heading from "../../../components/heading/heading.component";
import Loading from "../../../components/loading/loading.component";
import {
  getAuctionDetails,
} from "../../../Services/auction.service";
import {
  CMAuctionData,
  CMAuctionDescription,
  CMAuctionDetails,
  CMCardContainer,
  CMCarouselContainer,
  CMDetails,
  CMMedia,
  CMSingleInfo,
} from "./auction-details.styles";
import { AUCTION_TYPE } from "../../../components/auctions/auction-status/auction-status.component";
import AuctionCard from "../../../components/auctions/auction-card/auction-card.component";
import {
  formatCommaNumbers,
  formatCurrency,
} from "../../../Utils/common.utils";
import YoutubeEmbed from "../../../components/youtube-embed/youtube-embed.component";
import { MainBox } from "../../../theme/global.styles";
import Financials from "../../../components/financials/financials.component";
import TrackList from "../../../components/track-list/track-list.component";
import {
  useMediaQuery,
} from "@mui/material";
import BackArrow from "../../../components/back-arrow/back-arrow.component";
import StatisticsAnalytics from "../../../components/statistics-analytics/statistics-analytics.component";
import AuctionAbout from "../../../components/auctions/auction-about/auction-about.component";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../../components/button/button.component";
import queryString from "query-string";
import SocialMediaShare from "../../../components/social-media/social-media-share.component";
import styled from "styled-components";
import { useAuth } from "../../../Contexts/auth.context";
import PopupError from "../../../components/auction-popups/errors/PopupError.component";
import HelpTooltip from "../../../components/help-tooltip/help-tooltip.component";

const hiddenColumns = {
  id: false,
  imgSrc: false,
  album: false,
  releaseDate: false,
  isrc: false,
  artist: false,
};

const desktopHiddenColums = {
  artist: false,
};

const AuctionDetails = () => {
  const [order, setOrder] = useState();
  const location = useLocation();
  const [auction, setAuction] = useState({});
  const [status, setStatus] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const isMobile = useMediaQuery("(max-width:992px)");
  const navigate = useNavigate();
  const [showFixedHeader, setShowFixedHeader] = useState(false);
  const [refreshDetailsPage, setRefreshDetailsPage] = useState(false);
  const { auth } = useAuth();
  const [openError, setOpenError] = useState(false);

  useEffect(() => {
    const scrollToElement = () => {
      const elementId = location.search.split('scrollTo=')[1];
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };
    if (location.search && location.search.includes('scrollTo=')) {
      setTimeout(scrollToElement, 2000);
    }
  }, [location.search]);

  useEffect(() => {
    const parseURL = queryString.parse(location.search);
    setOrder(parseURL.id);
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Set the desired scroll threshold value
      const scrollThreshold = 40;

      // Toggle the visibility of the fixed header based on the scroll position
      setShowFixedHeader(scrollTop > scrollThreshold);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (order) {
      getAuctionDetails(order, auth.userId)
        .then((response) => {
          if (response) {
            setAuction(response);
            if (response.videos) {
              const tmpVideos = response.videos;
              setVideos(tmpVideos);
            }
          }
        })
        .catch((err) => setStatus(err))
        .finally(() => setLoading(false));
    }
  }, [order, refreshDetailsPage]);
  /*useEffect(() => {
   console.log('in status.ended event='+values.ended);
  }, [values.ended]);*/
  // useEffect(() => {
  //     albumTest().then(response => {
  //         if(response) {
  //             const tmpTracks = response.map((track, index) => {
  //                 return {
  //                     ...track,
  //                     id: track.isrc,
  //                     title: track.name,
  //                     releaseDate: track.release_dates[3],
  //                     album: 'Nevermid',
  //                     artist: 'Nirvana'
  //                 }
  //             })
  //             setTracks(tmpTracks);
  //         }
  //     });

  //     artistTest().then(response => {
  //         if(response) {
  //             setArtist({...response, mentions: auction.mentions});
  //         }
  //     });
  // }, [auction]);

  /*if(status) {
    throw new Error(status);
  }*/

  const isVideo = (link) => {
    if (link === 'video') {
      return true
    }
    return false;
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      console.error("Formato de URL inválido:", e);
      return false;
    }
  };

  const handleCloseError = () => {
    setOpenError(false);
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (Object.keys(auction).length === 0) {
        setOpenError(true);
      } else {
        setOpenError(false);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [auction]);

  const handleBack = () => {
    if (new URLSearchParams(location.search).has('p')) {
      navigate("/portfolio");
    } else {
      navigate("/auctions-board");
    }
  };


  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <PopupError
            open={openError}
            onClose={handleCloseError}
            Title={"Connection problems"}
            SubTitle={"The site is experiencing problems please contact an administrator."} />
          <CMAuctionDetails>
            <MainBox className="dotted-border">
              <BackArrow handleBack={handleBack} />
              {!isMobile && <SocialMediaShare className="socialMediaAlign" hideLinks={true} auctionName={auction?.title + '/' + auction?.assetName} isWatch={auction?.IsWatch} auctionID={auction?.id} />}
              <Heading previusPage={"Auction symbol"} currentPage={auction?.symbol} />
              {isMobile && <SocialMediaShare className="socialMediaAlign" hideLinks={true} auctionName={auction?.title + '/' + auction?.assetName} isWatch={auction?.IsWatch} auctionID={auction?.id} />}
              <CMDetails>
                <div className="ContainerMobile">
                <CMCarouselContainer>
                  {auction && (
                    <AuctionCarousel
                      slides={auction.imgSrc || [""]}
                      carouselType={AUCTION_CAROUSEL_TYPE.imageSemiRounded}
                      breakpoints={imgBreakpoints}
                      auctionID={auction.auctionID}
                    />
                  )}
                </CMCarouselContainer>
                <CMAuctionDescription>
                  <div className="CMAuctionButtonDiv">
                    <span>{auction?.symbolType}</span>
                    <h1>{auction?.assetName}</h1>
                    <div className="CMAuctionButtonDivButton">
                      {auction.genreArray && auction.genreArray.length > 0
                        ? auction.genreArray.map((genre, index) => (
                          <Button
                            key={index}
                            buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}
                            color="gray"
                            size="small"
                            shape="squared"
                            className="CMAuctionGenereButton"
                          >
                            {genre?.value || genre}
                          </Button>
                        ))
                        : ""}
                    </div>
                  </div>
                  
                  <CMAuctionData>
                  <h4>Auction Details</h4>
                    <div>
                      <div className="tooltip-content">Number of units <HelpTooltip title={"Total number of fractional royalty units offered in this auction."} /></div>
                      <div>{formatCommaNumbers(auction?.units)}</div>
                    </div>
                    <div>

                      <div className="tooltip-content">Auction target <HelpTooltip title={"The total amount the issuer aims to raise through the auction."} /></div>
                      <div>{formatCurrency(auction?.minAuctionTarget)}</div>
                    </div>
                    <div>
                      <div className="tooltip-content">Target Price per Unit <HelpTooltip title={"The desired price per unit, based on the issuer's valuation goal."} /></div>
                      <div>{auction?.targetPricePerUnit}</div>
                    </div>
                  </CMAuctionData>
                </CMAuctionDescription>
                </div>
               
                <CMCardContainer>
                  <AuctionCard
                    auction={auction}
                    setAuction={setAuction}
                    cardType={AUCTION_TYPE.details.id}
                    setRefreshDetailsPage={setRefreshDetailsPage}
                    refreshDetailsPage={refreshDetailsPage}
                  />
                </CMCardContainer>
              </CMDetails>
            </MainBox>
            <MainBox>
              <Financials auction={auction} />
              {/* <About auction={auction} /> */}
              {/* <TrackList tracks={auction.tracks} hiddenColumns={isMobile ? hiddenColumns : {}} /> */}
            </MainBox>

            {videos.length > 0 && (videos[0].link || (auction.tracks && auction.tracks[0].spotifyLink)) ? (
              <CMMedia>
                  <MainBox>
                    <h4>Media</h4>
                    <CMSlide>
                      {videos.map((video, index) =>
                        video.link && (
                          <YoutubeEmbed
                            key={index} 
                            source={video.link}
                            thumbnail={video.thumbnail}
                            width={280}
                            height={180}
                            auctionID={auction.auctionID}
                          />
                        )
                      )}
                  </CMSlide>
                  {/* <div><AuctionCarousel slides={videos} carouselType={AUCTION_CAROUSEL_TYPE.video} breakpoints={videoBreakpoints} height={130} /></div> */}
                </MainBox>
              </CMMedia>
            ) : (
              <CMMedia>
                <MainBox>
                  <h4>Media</h4>
                  <div id="noMedia">
                    {auction.spotifyLink ? (
                      <a href={new URL(`https://${auction.spotifyLink}`).href}>
                        Link
                      </a>
                    ) : (
                      <p>No media</p>
                    )}
                  </div>
                  {/* <div><AuctionCarousel slides={videos} carouselType={AUCTION_CAROUSEL_TYPE.video} breakpoints={videoBreakpoints} height={130} /></div> */}
                </MainBox>
              </CMMedia>
            )}

            <MainBox className="dotted-border" id="tracks">
              <TrackList
                tracks={auction.tracks}
                hiddenColumns={isMobile ? hiddenColumns : desktopHiddenColums}
                totaltracks={auction.totaltracks}
              />
            </MainBox>

            <AuctionAbout auction={auction} symbolType={"Single"} />
            <StatisticsAnalytics auction={auction} symbolType={"Single"} hiddenC={false} />
          </CMAuctionDetails>
        </>
      )}
    </>
  );
};

export default AuctionDetails;

//  this component is used to display the videos at the bottom of the auction item
export const CMSlide = styled.div` 
  display: flex;
  margin-top: 20px;  
  width: 100%;
  box-sizing: border-box;
  gap: 10px;
  padding: 10px;
  overflow-y: hidden;   
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;  
  scroll-snap-type: x mandatory;  
  scroll-behavior: smooth;  
  padding-bottom: 10px !important; 
  scrollbar-width: thin;
  scrollbar-color: rgb(168, 0, 0) transparent; 

  @media (max-width: 1023px) {
    margin: 0;
    padding: 0;
    margin-top: -20px;
    margin-bottom: 25px;
  }
  
   ::-webkit-scrollbar {
    width:8px; 
    height: 8px;
    border-radius: 8px; 
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(168, 0, 0); 
    border-radius: 10px; 
  }
`;